var filePath = "http://192.168.2.36:8060/wwwroot"; 
var testUrlPath = "https://lyapp.gispai.com"; 
 // var testUrlPath = "https://pro.gispai.com"
//真实环境api地址
// var GbaseUrl = "https://pro.gispai.com/"; 
var GbaseUrl = "https://lyapp.gispai.com"; 
 
var canuseUserIDs=[1,2,5,17,3359,14,7,3460,3574,3437,3783,4175] //控制哪些用户可使用新功能
var myConfig = {
  baseUrl: GbaseUrl,
  imgUrl: GbaseUrl + '/files/GDataStore',
  imgUrl1: GbaseUrl, 
  gspServiceUrl: "http://server.gispai.com/MapServerAPI",
  openMapImageUrl: GbaseUrl + "/files/OpenMap/OpenMapImage/",
  GDataJsonFileUrl: GbaseUrl + "GData/",
  serverPort: "8060",
  testUrl: testUrlPath,
	filePath,
  defaultSymbol: "&#xe601;" ,//默认符号
	canuseUserIDs:canuseUserIDs
}

export {myConfig}
 




 